import(/* webpackMode: "eager" */ "/workspace/dotheforgejo/oxpa-pro/src/app/(portal)/claim/page.tsx");
